<template>
  <div
    ref="userTrainingOverviewElem"
    class="user-training-part part list"
    v-if="data && data !== ''"
    :class="{ completed: data?.state === 'Completed' || data.state === 'Complited' }"
  >
    <div class="thumb-side" v-if="data?.overviewImage?.url">
      <span
        class="bg-el"
        v-if="data.overviewImage.url"
        v-bind:style="{
          'background-image': 'url(' + data.overviewImage.url + ')'
        }"
      ></span>
    </div>
    <div class="content-side">
      <div class="big-title-wrapper">
        <h2 v-if="data?.displayTitle" class="part-title">{{ data.displayTitle }}</h2>
        <h2 v-else class="part-title">{{ data.title }}</h2>

        <div class="tags-wrapper">
          <ul class="labels" v-if="data.fields">
            <li v-if="data.fields.tijdsduur && data.fields.tijdsduur.length > 0">
              <div class="item-wrapper" v-for="item in data.fields.tijdsduur" :key="item.value">
                <span class="label-wrapper">
                  {{ getEnumVal(item.value) }}
                </span>
              </div>
            </li>
            <li>
              <div class="item-wrapper" v-if="data?.totalQuestionsCount">
                <span class="label-wrapper">
                  {{ data?.totalQuestionsCount }}
                  <template v-if="data.totalQuestionsCount == 1">vraag</template>
                  <template v-else>vragen</template>
                </span>
              </div>
            </li>
          </ul>
        </div>
      </div>

      <div class="part-intro" v-if="data.subtitle" v-html="data.subtitle"></div>
    </div>

    <div class="mobile-intro-wrapper">
      <div class="part-intro" v-if="data.subtitle" v-html="data.subtitle"></div>
    </div>

    <div class="button-side">
      <template v-if="!data.trainingClosed">
        <router-link
          v-if="data?.state === 'Completed' || data.state === 'Complited'"
          class="button completed"
          :to="'/thema/' + data.id"
          >Afgerond</router-link
        >

        <router-link
          v-else-if="data.state === 'InProgress'"
          class="button in-progress alt"
          :to="'/thema/' + data.id"
          >Verder gaan</router-link
        >

        <router-link v-else class="button start" :to="'/thema/' + data.id">Start</router-link>
      </template>
      <template v-else>
        <button
          v-if="data?.state === 'Completed' || data.state === 'Complited'"
          class="button completed"
          :disabled="true"
        >
          Afgerond
        </button>

        <button v-else-if="data.state === 'InProgress'" class="button in-progress alt" :disabled="true">
          Verder gaan
        </button>

        <button v-else class="button start" :disabled="true">Start</button>
      </template>
    </div>
  </div>
</template>

<script>
//Vue
import { defineComponent, computed, ref, watch, onMounted } from 'vue'

import { resolveEnum } from '@/utils/global'

//Composables
import { useAuthenticationData } from '@/composables/useAuthenticationData'

import Popup from '@/components/Popup/index.vue'

export default defineComponent({
  components: {
    Popup
  },
  props: {
    observer: null,
    data: {
      type: Object,
      default: () => {}
    },
    enrolledData: {
      type: Object,
      default: () => {}
    }
  },
  emits: ['sortUp', 'sortDown', 'deleteItem'],
  setup(props, { emit }) {
    const isAuthenticated = computed(() => {
      return useAuthenticationData().data.value.isAuthenticated
    })

    const userTrainingOverviewElem = ref(null)

    onMounted(() => {
      countStageElements()

      if (props.observer !== null && props.observer !== undefined) {
        props.observer.observe(userTrainingOverviewElem.value)
      }
    })

    function getEnumVal(val) {
      return resolveEnum(val)
    }

    function fullDateFormatted(date) {
      let initialDate = date

      //Timezone offset
      //let hrs = -(new Date().getTimezoneOffset() / 60);

      // const months = [
      //     "Jan.",
      //     "Feb.",
      //     "Mrt.",
      //     "Apr.",
      //     "Mei.",
      //     "Jun.",
      //     "Jul.",
      //     "Aug.",
      //     "Sept.",
      //     "Okt.",
      //     "Nov.",
      //     "Dec.",
      // ];

      let d = new Date(initialDate)

      const addZero = (i) => {
        if (i < 10) {
          i = '0' + i
        }
        return i
      }

      const monthIndex = addZero(d.getMonth() + 1)
      //const monthName = months[monthIndex];
      const year = d.getFullYear()
      const day = addZero(d.getDate())
      // const hours = addZero(d.getHours() + hrs);
      // const minutes = addZero(d.getMinutes());

      return day + '-' + monthIndex + '-' + year
    }

    function countStageElements() {
      const fieldTypes = [
        'short-text',
        'long-text',
        'number',
        'multiple-choice',
        'single-choice',
        'dropdown',
        'image-choice',
        'file-upload'
      ]

      if (props.data?.trainingStages?.length) {
        props.data.trainingStages.forEach((stage) => {
          stage.trainingStageElements?.forEach((stageElement) => {
            if (stageElement?.videoContent) {
              videoAmount.value++
            }

            stageElement.question?.questionSteps?.forEach((tab) => {
              tab.fields?.forEach((field) => {
                // Only count when it is NOT a visual field
                if (fieldTypes.includes(field.type)) {
                  questionAmount.value++
                }
              })
            })
          })
        })
      }
    }

    return {
      isAuthenticated,
      userTrainingOverviewElem,
      fullDateFormatted,
      countStageElements,
      getEnumVal
    }
  }
})
</script>

<style lang="scss" scoped>
// @import styles
@import './index.scss';
</style>
